module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_5.88cb3dd2.png";